import type { Product } from '@/api/types';

export interface FilterState {
  country: string;
  group: string;
  price: string;
  date: string;
  duration: string;
  /** Geographic filter — destination id (or 'all'). */
  where: string;
  /** Free-text search query over title / shortDescription / description. */
  q: string;
  [key: string]: string;
}

export const defaultFilters: FilterState = {
  country: 'all',
  group: 'all',
  price: 'all',
  date: 'all',
  duration: 'all',
  where: 'all',
  q: '',
};

export interface SelectionState {
  product?: Product;
  startDate: string; // ISO yyyy-mm-dd
  adults: number;
  rooms: number;
}

type Listener<T> = (state: T) => void;

class Observable<T extends object> {
  private state: T;
  private listeners = new Set<Listener<T>>();

  constructor(initial: T) {
    this.state = initial;
  }

  get(): Readonly<T> {
    return this.state;
  }

  set(patch: Partial<T>): void {
    this.state = { ...this.state, ...patch };
    this.notify();
  }

  replace(next: T): void {
    this.state = next;
    this.notify();
  }

  subscribe(fn: Listener<T>): () => void {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  }

  private notify(): void {
    for (const fn of this.listeners) {
      fn(this.state);
    }
  }
}

function defaultStartDate(): string {
  const d = new Date();
  d.setDate(d.getDate() + 30);
  return d.toISOString().slice(0, 10);
}

export const filtersStore = new Observable<FilterState>({ ...defaultFilters });

export const selectionStore = new Observable<SelectionState>({
  product: undefined,
  startDate: defaultStartDate(),
  adults: 2,
  rooms: 1,
});
